/**
 * Helpers — services / modules activés sur une boutique.
 */

export function isStockManagementEnabled(commercant) {
  return Boolean(commercant?.stock_management_enabled);
}

/** Afficher l'entrée « Ingrédients & ruptures » (menu + onglet) — boutique avec produits et/ou prestations. */
export function shouldShowStockNavigation(commercant) {
  return Boolean(commercant?.moduleProduits || commercant?.modulePrestations);
}

/** Accès effectif au module stock : permission GESTION_STOCK activée OU flag stock_management_enabled */
export function canUseStockManagement(commercant, permissions) {
  if (!shouldShowStockNavigation(commercant)) return false;
  if (isStockManagementEnabled(commercant)) return true;
  if (Array.isArray(permissions)) return permissions.includes('GESTION_STOCK');
  return false;
}
